import DisabledAlertTemplateSelector from './DisabledAlertTemplateSelector';
import DisabledAlertUpgradeRequired from './DisabledAlertUpgradeRequired';
import DisabledAlertDuplicateThread from './DisabledAlertDuplicateThread';
import { SHOW_TEMPLATE, UPGRADE_REQUIRED, DUPLICATE_THREAD, OPTED_OUT, CHANNEL_INSTANCE_DISABLED_OR_DELETED } from 'composer-data/disable-editor/public/constants';
import DisabledAlertOptedOut from './DisabledAlertOptedOut';
import { SMS_GENERIC_CHANNEL_ID, WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import DisabledAlertBase from './DisabledAlertBase';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledEditor = ({
  recipientId,
  message,
  threadId,
  newestThreadId,
  messageLimitData,
  reason,
  currentEditorKey
}) => {
  switch (currentEditorKey) {
    case WHATSAPP_GENERIC_CHANNEL_ID:
      switch (reason) {
        case CHANNEL_INSTANCE_DISABLED_OR_DELETED:
          return /*#__PURE__*/_jsx(DisabledAlertBase, {
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "composer-ui.capability-editor.disabled-editor.whatsapp.disabledOrDeletedChannelInstance"
            }),
            type: "warning"
          });
        case SHOW_TEMPLATE:
          return /*#__PURE__*/_jsx(DisabledAlertTemplateSelector, {
            recipientId: recipientId,
            message: message,
            threadId: threadId,
            messageLimitData: messageLimitData
          });
        case UPGRADE_REQUIRED:
          return /*#__PURE__*/_jsx(DisabledAlertUpgradeRequired, {
            message: message
          });
        case DUPLICATE_THREAD:
          return /*#__PURE__*/_jsx(DisabledAlertDuplicateThread, {
            message: message,
            newestThreadId: newestThreadId
          });
        default:
          return null;
      }
    case SMS_GENERIC_CHANNEL_ID:
      switch (reason) {
        case OPTED_OUT:
          return /*#__PURE__*/_jsx(DisabledAlertOptedOut, {
            message: message
          });
        default:
          return null;
      }
    default:
      return null;
  }
};
DisabledEditor.displayName = 'DisabledEditor';
export default DisabledEditor;